import register from '../../../../global/js/registry';
export default register('o-form-stepper', () => import(/* webpackMode: "lazy" */ './o-form-stepper.controller'));
